export default __webpack_public_path__ + "static/media/icons-menu-map.00bd4a52.svg";